<template>
  <div>
    <page-title icon="fa fa-address-book" main="Ficha Cadastral PJ">
      <template v-slot:actions>
        <base-button
          @click="newJuridical()"
          type="neutral"
          class="ml-3"
          size="sm"
          >Cadastrar</base-button
        >
      </template>
    </page-title>
    <!-- Filters -->
    <div class="card mt-2" style="padding: 1rem">
      <form>
        <div class="row">
          <div class="col-md-6">
            <base-input
              label="Nome do Jurídico"
              placeholder="Nome do Jurídico"
              v-model="filter.name"
            />
          </div>
          <div class="col-md-2">
            <label class="form-control-label"> Ano Safra </label>
            <multiselect
              v-model="filter.anosafra"
              :options="safras"
              label="descricao"
              track-by="value"
              placeholder="Selecionar Safra"
              select-label=""
              deselect-label=""
              selected-label=""
            />
          </div>
          <div class="col-md-2">
            <label class="form-control-label"> Status </label>
            <multiselect
              v-model="filter.status"
              :options="juridical_statuses"
              label="label"
              track-by="value"
              select-label=""
              deselect-label=""
              selected-label=""
            />
          </div>
          <div class="col-md-2">
            <div style="margin-top: 2rem">
              <base-button icon type="primary" v-on:click="getJuridicalsWithDocumentation">
                <span class="btn-inner--icon">
                  <i class="fa fa-search"></i>
                </span>
                <span class="btn-inner--text">Pesquisar</span>
              </base-button>
            </div>
          </div>
        </div>
      </form>
      <!-- Header form -->
      <modal :show.sync="modals.header" id="cliente" size="lg" @save="save">
        <h2>CABEÇALHO</h2>
        <div class="row">
          <div class="col-6 mt-3 mb-3">
            <label class="form-control-label">Ano Safra</label><br />
            <multiselect
              v-model="safra"
              :options="safras"
              :disabled="true"
              label="descricao"
              placeholder="Selecionar Safra"
            />
          </div>
          <div class="col-6 mt-3 mb-3">
            <label class="form-control-label">Gerente Comercial</label><br />
            <multiselect
              v-model="manager"
              :options="managers"
              label="name"
              track-by="id"
              placeholder="Selecionar Gerente Comercial"
            />
          </div>
          <div class="col-md-6">
            <label class="form-control-label">Vendedor</label>
            <multiselect
              v-model="consultant"
              :options="users"
              label="name"
              track-by="id"
              placeholder="Selecionar Vendedor"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
            />
          </div>
          <div class="col-md-6">
            <label class="form-control-label">Cliente</label>
              <multiselect
                v-model="filter.clientChoosed"
                :options="clients"
                placeholder="Selecionar Clientes"
                label="razao_social"
                :select-label="''"
                :deselect-label="''"
                :selected-label="'Selecionado'"
                track-by="id"
                @search-change="setClients"
              />
          </div>
        </div>
        <template slot="footer">
          <base-button type="secondary" @click="modals.header = false">
            Fechar
          </base-button>
          <base-button type="success" @click="modalValidation">
            Continuar
          </base-button>
        </template>
      </modal>

      <!-- Transform modal component -->
      <modal :show.sync="modals.juridicalForm" :mouseDownOn="false" id="cliente" size="lg" >
        <div class="col-12">
          <wizard :loading="isSaving" @save="save" @update="update">
            <wizard-tab title="Ficha Cadastral Pessoa Jurídica">
              <div class="row" style="padding-top: 20px">
                <div class="col-12">
                  <base-input
                    type="text"
                    label="RAZÃO SOCIAL"
                    v-model="filter.juridical.name"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-12">
                  <base-input
                    type="text"
                    label="ENDEREÇO"
                    v-model="filter.juridical.endereco"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-6">
                  <base-input
                    type="text"
                    label="CNPJ"
                    v-model="filter.juridical.cpf"
                    :disabled="isEditing"
                    mask="cnpj"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-6">
                  <base-input
                    type="text"
                    label="CIDADE"
                    v-model="filter.juridical.municipio"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-6">
                  <base-input
                    type="text"
                    label="ESTADO"
                    v-model="filter.juridical.uf"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-6">
                  <base-input
                    label="CEP"
                    mask="cep"
                    v-model="filter.juridical.cep"
                    :required="true"
                  ></base-input>
                </div>

                <!-- Save type and size for credit module (cri) -->
                <div class="col-12 mb-3">
                  <label class="form-control-label">Tipo de Cliente</label>
                  <multiselect
                    v-model="cri_client.client_type"
                    :options="client_types"
                    :required="true"
                    label="name"
                    track-by="value"
                    placeholder="Selecione um tipo de cliente"
                    :select-label="''"
                    :deselect-label="''"
                    :selected-label="'Selecionado'"
                  ></multiselect>
                </div>
                <div class="col-12 mb-3">
                  <label class="form-control-label">Porte do Cliente</label>
                  <multiselect
                    v-model="cri_client.client_size"
                    :options="client_sizes"
                    :required="true"
                    label="name"
                    track-by="value"
                    placeholder="Selecione o porte"
                    :select-label="''"
                    :deselect-label="''"
                    :selected-label="'Selecionado'"
                  ></multiselect>
                </div>

                <div class="col-6">
                  <base-input
                    type="text"
                    label="EMAIL"
                    v-model="filter.juridical.email"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-6">
                  <base-input
                    type="text"
                    label="TELEFONE"
                    v-model="filter.juridical.primary_phone"
                    :required="true"
                    @keydown.backspace="onPhoneKeydown"
                    @keyup="handleOnKeyUp"
                  ></base-input>
                </div>

                <div class="col-6">
                  <base-input
                    type="text"
                    label="INSCRIÇÃO ESTADUAL"
                    v-model="filter.juridical.state_registration"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-6">
                  <base-input
                    type="text"
                    label="ENDEREÇO P/ COBRANÇA"
                    v-model="filter.juridical.billing_address"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-6">
                  <base-input
                    type="text"
                    label="RAMO DE NEGÓCIO"
                    v-model="filter.juridical.business"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-6">
                  <base-input
                    type="number"
                    label="CAPITAL INICIAL"
                    v-model="filter.juridical.initial_capital"
                    :required="true"
                    placeholder="10.000,00"
                  ></base-input>
                </div>

                <div class="col-6">
                  <base-input
                    type="number"
                    label="CAPITAL ATUAL:"
                    v-model="filter.juridical.current_capital"
                    :required="true"
                    placeholder="20.000,00"
                  ></base-input>
                </div>

                <div class="col-6">
                  <base-input
                    type="text"
                    label="DENOMINAÇÃO ANTERIOR"
                    v-model="filter.juridical.previous_denomination"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-6">
                  <base-input
                    type="text"
                    label="NOME DO CONTATO (P/PAGAMENTOS)"
                    v-model="filter.juridical.name_contact_payment"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-6 mt-3">
                  <base-input
                    type="text"
                    label="TELEFONE"
                    v-model="filter.juridical.secondary_phone"
                    :required="true"
                    @keydown.backspace="onPhoneKeydown"
                    @keyup="handleOnKeyUp"
                  ></base-input>
                </div>
              </div>
              <br />
              <div>
                <label
                  class="form-control-label"
                  style="color: #8898aa; margin-bottom: 0; font-size: 0.8125rem"
                  >QUADRO SOCIETÁRIO</label
                >
                <base-button
                  type="secundary"
                  @click="addCorporate_structures"
                  size="sm"
                  style="color: #2dce89"
                  class="ml-3"
                  ><i class="ni ni-fat-add"></i>Adicionar
                  Societário</base-button
                >
                <div
                  class="row"
                  style="padding-top: 20px"
                  v-for="corporate_structures in filter.juridical.corporate_structures_attributes"
                  :key="corporate_structures.id"
                >
                  <div class="col-12">
                    <base-input
                      type="text"
                      label="DIRETORES/SÓCIOS/ACIONISTAS"
                      v-model="
                        corporate_structures.partner_directors_shareholders
                      "
                      :required="true"
                    ></base-input>
                  </div>

                  <div class="col-6">
                    <base-input
                      type="text"
                      label="CPF"
                      v-model="corporate_structures.cpf"
                      mask="cpf"
                      :required="true"
                    ></base-input>
                  </div>

                  <div class="col-6">
                    <base-input
                      type="text"
                      label="CARGO"
                      v-model="corporate_structures.office"
                      :required="true"
                    ></base-input>
                  </div>

                  <div class="col-6">
                    <base-input
                      type="text"
                      label="PARTICIPAÇÃO %"
                      v-model="corporate_structures.participation"
                      :required="true"
                    ></base-input>
                  </div>
                  <base-button
                    class="col-4 mb-3 mt-4"
                    size="sm"
                    type="secundary"
                    @click="removeCorporate_structures(corporate_structures)"
                    style="color: #f5365c; height: 3rem;"
                    >
                    <i class="ni ni-fat-delete"></i>Remover Quadro
                  </base-button>
                </div>
              </div>
            </wizard-tab>

            <wizard-tab title="Filiais">
              <base-button
                class="button-culture"
                type="secundary"
                @click="addAffiliated_societies"
                size="sm"
                style="color: #2dce89"
                ><i class="ni ni-fat-add"></i>Adicionar Filiais</base-button
              >
              <div
                v-for="affiliated_societies in filter.juridical.affiliated_societies_attributes"
                :key="affiliated_societies.id"
                class="row"
                style="padding-top: 20px"
              >
                <div class="col-5">
                  <base-input
                    type="text"
                    label="ENDEREÇO"
                    v-model="affiliated_societies.address"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-5">
                  <base-input
                    type="text"
                    v-model="affiliated_societies.town"
                    label="CIDADE"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-5">
                  <base-input
                    type="text"
                    v-model="affiliated_societies.state"
                    label="ESTADO"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-5">
                  <base-input
                    type="text"
                    v-model="affiliated_societies.cnpj"
                    label="CNPJ"
                    mask="cnpj"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-md-2" style="position: relative">
                  <div style="position: absolute; top: 32%">
                    <base-button
                      type="secundary"
                      @click="removeAffiliated_societies(affiliated_societies)"
                      style="color: #f5365c"
                      ><i class="ni ni-fat-delete"></i
                    ></base-button>
                  </div>
                </div>
              </div>
            </wizard-tab>

            <wizard-tab title="PARTICIPAÇÃO EM OUTRAS EMPRESAS">
              <base-button
                class="button-culture"
                type="secundary"
                @click="addDesks"
                size="sm"
                style="color: #2dce89"
                ><i class="ni ni-fat-add"></i>Adicionar Participação em outras
                empresas</base-button
              >
              <div
                v-for="desks in filter.juridical.desks_attributes"
                :key="desks.id"
                class="row"
                style="padding-top: 20px"
              >
                <div class="col-5">
                  <base-input
                    type="text"
                    label="NOME DA EMPRESA"
                    v-model="desks.company_name"
                    :required="true"
                  ></base-input>
                </div>
                <div>
                  <base-input
                    type="text"
                    label="CNPJ"
                    v-model="desks.cnpj"
                    mask="cnpj"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-5">
                  <base-input
                    type="number"
                    v-model="desks.share_capital"
                    label="CAPITAL SOCIAL"
                    :required="true"
                    placeholder="20.000,00"
                  ></base-input>
                </div>

                <div class="col-5">
                  <base-input
                    type="number"
                    v-model="desks.participation"
                    label="PARTICIPAÇÃO %"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-md-2" style="position: relative">
                  <div style="position: absolute; top: 32%">
                    <base-button
                      type="secundary"
                      @click="removeParticipation(desks)"
                      style="color: #f5365c"
                      ><i class="ni ni-fat-delete"></i
                    ></base-button>
                  </div>
                </div>
              </div>
            </wizard-tab>

            <wizard-tab title="IMÓVEIS (EMPRESA/SÓCIOS)">
              <base-button
                class="button-culture"
                type="secundary"
                @click="addReal_estate_companies"
                size="sm"
                style="color: #2dce89"
                ><i class="ni ni-fat-add"></i>Adicionar Imóveis</base-button
              >
              <div
                v-for="real_estate_companies in filter.juridical.real_estate_companies_attributes"
                :key="real_estate_companies.id"
                class="row"
                style="padding-top: 20px"
              >
                <div class="col-5">
                  <base-input
                    type="text"
                    v-model="real_estate_companies.description"
                    label="DESCRIÇÃO ( Tipo - Área )"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-5">
                  <base-input
                    type="text"
                    v-model="real_estate_companies.localization"
                    label="LOCALIZAÇÃO"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-5">
                  <base-input
                    type="number"
                    v-model="real_estate_companies.current_value"
                    label="VALOR ATUAL (R$)"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-5">
                  <base-input
                    type="number"
                    v-model="real_estate_companies.liens_mortgage"
                    label="ÔNUS/HIPOTECA"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-md-2" style="position: relative">
                  <div style="position: absolute; top: 32%">
                    <base-button
                      type="secundary"
                      @click="removeReal_estate(real_estate_companies)"
                      style="color: #f5365c"
                      ><i class="ni ni-fat-delete"></i
                    ></base-button>
                  </div>
                </div>
              </div>
            </wizard-tab>

            <wizard-tab title="PRINCIPAIS CLIENTES">
              <base-button
                class="button-culture"
                type="secundary"
                @click="addMain_customers"
                size="sm"
                style="color: #2dce89"
                ><i class="ni ni-fat-add"></i>Adicionar Clientes</base-button
              >
              <div
                v-for="main_customers in filter.juridical.main_customers_attributes"
                :key="main_customers.id"
                class="row"
                style="padding-top: 20px"
              >
                <div class="col-12">
                  <br />
                  <base-input
                    type="text"
                    label="NOME"
                    v-model="main_customers.name"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-12">
                  <label>Selecione CPF ou CNPJ</label><br/>
                  <input name="option" type="radio" id="CPF" value="CPF" v-model="picked" />
                  <label style="margin-left: 3px" for="CPF">CPF</label>
                  <input style="margin-left: 15px" name="option" type="radio" id="CNPJ" value="CNPJ" v-model="picked" />
                  <label style="margin-left: 3px" for="CNPJ">CNPJ</label> <br/><br/>
                </div>

                <div class="col-12" v-show="picked=='CPF'">
                  <base-input
                    type="text"
                    label="CPF"
                    v-model="main_customers.cpf_cnpj"
                    mask="cpf"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-12" v-show="picked=='CNPJ'">
                  <base-input
                    type="text"
                    label="CNPJ"
                    v-model="main_customers.cpf_cnpj"
                    mask="cnpj"
                    :required="true"
                  ></base-input>
                </div>

                <!--
                <div class="col-12">
                  <base-input
                    type="number"
                    label="MÉDIA VENDAS (R$)"
                    v-model="main_customers.average_sales"
                    :required="true"
                    placeholder="5.000,00"
                  ></base-input>
                </div>
                -->

                <div class="col-12">
                  <base-input
                    type="number"
                    label="PART. % CONTAS REC."
                    v-model="main_customers.participation"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-md-2" style="position: relative">
                  <div style="position: absolute; top: 32%">
                    <base-button
                      type="secundary"
                      @click="removeMain_customers(main_customers)"
                      style="color: #f5365c"
                      ><i class="ni ni-fat-delete"></i
                    ></base-button>
                  </div>
                </div>
              </div>
            </wizard-tab>

            <wizard-tab title="PESSOAS AUTORIZADAS À RECEBER MERCADORIAS">
              <base-button
                type="secundary"
                @click="addAuthorized_people"
                size="sm"
                style="color: #2dce89"
                ><i class="ni ni-fat-add"></i>Adicionar Societário</base-button
              >

              <div
                class="row"
                style="padding-top: 20px"
                v-for="authorized_people_legals in filter.juridical.authorized_people_legals_attributes"
                :key="authorized_people_legals.id"
              >
                <div class="col-12">
                  <base-input
                    type="text"
                    label="NOME"
                    v-model="authorized_people_legals.name"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-12">
                  <base-input
                    type="number"
                    label="RG"
                    v-model="authorized_people_legals.rg"
                    :required="true"
                    mask="rg"
                  ></base-input>
                </div>

                <div class="col-md-2" style="position: relative">
                  <div style="position: absolute; top: 32%">
                    <base-button
                      type="secundary"
                      @click="removeAuthorized(authorized_people_legals)"
                      style="color: #f5365c"
                      ><i class="ni ni-fat-delete"></i
                    ></base-button>
                  </div>
                </div>
              </div>
            </wizard-tab>

            <wizard-tab title="INFORMAÇÕES COMERCIAIS E BANCÁRIAS">
              <base-button
                class="button-imovel"
                type="secundary"
                @click="addCommercial"
                size="sm"
                style="color: #2dce89"
                ><i class="ni ni-fat-add"></i>Adicionar Informações Comerciais
              </base-button>
              <div
                v-for="commercial in filter.juridical.commercial_bankings_attributes"
                :key="commercial.id"
                class="row"
                style="padding-top: 20px"
              >
                <div class="col-5">
                  <base-input
                    type="text"
                    label="EMPRESA"
                    v-model="commercial.company"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-5">
                  <base-input
                    type="text"
                    label="TELEFONE"
                    v-model="commercial.telephone"
                    :required="true"
                    @keydown.backspace="onPhoneKeydown"
                    @keyup="handleOnKeyUp"
                  ></base-input>
                </div>

                <div class="col-5">
                  <base-input
                    type="text"
                    label="CONTATO"
                    v-model="commercial.contact"
                    :required="true"
                  ></base-input>
                </div>
                <div class="col-md-2" style="position: relative">
                  <div style="position: absolute; top: 32%">
                    <base-button
                      type="secundary"
                      @click="removeCommercial(commercial)"
                      style="color: #f5365c"
                      ><i class="ni ni-fat-delete"></i
                    ></base-button>
                  </div>
                </div>
              </div>
              <label
                class="form-control-label"
                style="color: #8898aa; margin-bottom: 0; font-size: 0.8125rem"
                >BANCOS</label
              >
              <base-button
                class="button-imovel"
                type="secundary"
                size="sm"
                style="color: #2dce89"
              >
              </base-button>
              <div
                v-for="commercial in filter.juridical.commercial_bankings_attributes"
                :key="commercial.id"
                class="row"
                style="padding-top: 20px"
              >
                <div class="col-5">
                  <base-input
                    type="text"
                    label="BANCO"
                    v-model="commercial.bank"
                    :required="true"
                  ></base-input>
                </div>
                <div class="col-5">
                  <base-input
                    type="number"
                    label="AGÊNCIA"
                    v-model="commercial.agency"
                    :required="true"
                  ></base-input>
                </div>
                <div class="col-md-2" style="position: relative">
                  <div style="position: absolute; top: 32%">
                    <base-button
                      type="secundary"
                      @click="removeCommercial(commercial)"
                      style="color: #f5365c"
                      ><i class="ni ni-fat-delete"></i
                    ></base-button>
                  </div>
                </div>
              </div>
            </wizard-tab>

            <wizard-tab title="PREENCHIMENTO VEGETAL AGRONEGÓCIOS">
              <!-- <base-button
                class="button-imovel"
                type="secundary"
                @click="addOpinion"
                size="sm"
                style="color: #2dce89"
              >
                <i class="ni ni-fat-add"></i>
                Adicionar Parecer Vendedor
              </base-button> -->
              <div
                v-for="seller_opinion in filter.juridical.seller_opinions_attributes"
                :key="seller_opinion.id"
                class="row"
                style="padding-top: 20px"
              >
                <div class="col-5">
                  <base-input
                    type="text"
                    label="Parecer do Vendedor"
                    v-model="seller_opinion.looks_like_salesman"
                    :required="true"
                  ></base-input>
                </div>
                <div class="col-5">
                  <base-input
                    type="text"
                    label="Parecer do Gerente Comercial"
                    v-model="seller_opinion.looks_like_manager"
                    :required="true"
                  ></base-input>
                </div>
                <div class="col-5">
                  <label class="form-control-label"
                    >Cliente Desde?</label
                  ><br />
                  <el-date-picker
                    v-model="seller_opinion.customer_since"
                    prefix-icon="fa fa-calendar"
                    format="d 'de' MMMM 'de' yyyy"
                  >
                  </el-date-picker>
                </div>

                <div class="col-5">
                  <base-input
                    type="text"
                    label="Data e Valor da Última Compra"
                    v-model="seller_opinion.last_purchase_date"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-5">
                  <base-input
                    type="text"
                    label="Data e Valor da Maior Compra"
                    v-model="seller_opinion.biggest_purchase_date"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-5">
                  <base-input
                    type="text"
                    label="Forma de pagamento"
                    v-model="seller_opinion.form_payment"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-5">
                  <base-input
                    type="number"
                    label="Limite de crédito"
                    v-model="seller_opinion.credit_limit"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-5">
                  <base-input
                    type="text"
                    label="Atraso médio"
                    v-model="seller_opinion.average_delay"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-5">
                  <base-input
                    type="text"
                    label="Conceito"
                    v-model="seller_opinion.concept"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-5">
                  <base-input
                    type="text"
                    label="Empresa"
                    v-model="seller_opinion.company"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-5">
                  <base-input
                    type="text"
                    label="Informante"
                    v-model="seller_opinion.informant"
                    :required="true"
                  ></base-input>
                </div>

                <div class="col-10">
                  <base-input
                    type="textarea"
                    label="Observação"
                    v-model="seller_opinion.comments"
                    :required="true"
                  ></base-input>
                </div>
                <!-- <div class="col-md-2" style="position: relative">
                  <div style="position: absolute; top: 32%">
                    <base-button
                      type="secundary"
                      @click="removeOpinion(seller_opinion)"
                      style="color: #f5365c"
                    >
                      <i class="ni ni-fat-delete"></i>
                    </base-button>
                  </div>
                </div> -->
              </div>
            </wizard-tab>
            <wizard-tab title="Anexos">
              <div
                class="row"
                v-for="(files, fileType) in groupedFiles"
                :key="fileType"
              >
                <div class="col-12" style="margin-top: 15px">
                  <label
                    class="form-control-label"
                    style="
                      color: #8898aa;
                      margin-bottom: 0;
                      font-size: 0.8125rem;
                    "
                  >
                    {{ translateFileType(fileType) }}
                  </label>
                </div>
                <div class="col-12" style="margin-top: 15px">
                  <file-input
                    :files="files"
                    @update:files="addFile($event, fileType)"
                    multiple
                  ></file-input>
                </div>
                <div class="col-12" style="margin-top: 15px">
                  <file-list
                    :files="files"
                    @remove="
                      filter.juridical.files = filter.juridical.files.filter((f) => f != $event)
                    "
                  />
                </div>
              </div>
            </wizard-tab>
          </wizard>
        </div>
      </modal>

      <div class="border-0 card-header">
        <h3 class="mb-0">Jurídico Cadastrados:</h3>
      </div>

      <el-table
        :data="documentations"
        class="table-responsive table-striped"
        header-row-class-name="thead-light"
        border
        style="width: 100%"
      >
        <el-table-column
          label="Status"
          prop="name"
          sortable
          width="150px"
          v-slot="{ row }"
        >
          <badge class="badge-dot mr-4" type v-if="!row.is_outdated">
            <i class="bg-success"></i> Atualizado
          </badge>
          <badge class="badge-dot mr-4" type v-else>
            <i class="bg-danger"></i> Desatualizado
          </badge>
        </el-table-column>
        <el-table-column
          label="Ano"
          prop="name"
          sortable
          width="100px"
          v-slot="{ row }"
        >
          {{ new Date(row.created_at).getFullYear() }}
        </el-table-column>
        <el-table-column
          label="Nome"
          prop="name"
          sortable
          style="width: 60%"
          v-slot="{ row }"
        >
          {{ row.name }}
        </el-table-column>

        <el-table-column
          label="Endereço"
          prop="endereco"
          sortable
          v-slot="{ row }"
        >
          {{ row.endereco }}
        </el-table-column>

        <el-table-column
          label="Ações"
          width="80px"
          prop="acoes"
          v-slot="{ row }"
        >
          <el-dropdown trigger="hover" class="dropdown" style="cursor: pointer">
            <span class="btn btn-sm btn-icon-only text-success">
              <i class="fas fa-ellipsis-v mt-2"></i>
            </span>
            <el-dropdown-menu
              class="dropdown-menu dropdown-menu-arrow show"
              slot="dropdown"
            >
              <a
                class="dropdown-item"
                v-if="$can('update', 'client')"
                href="#"
                @click="edit(row)"
                >Editar</a
              >
            </el-dropdown-menu>
          </el-dropdown>
        </el-table-column>
      </el-table>
      <div slot="footer" class="py-4 d-flex justify-content-end">
        <base-pagination
          @input="getJuridical"
          v-model="paginated_data['current']"
          :total="paginated_data['count']"
          :perPage="paginated_data['per_page']"
        ></base-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import PageTitle from "@/layouts/PageTitle";
import FileList from "@/components/FileList";
import flatPicker from "vue-flatpickr-component";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


import Wizard from "@/components/Wizard/Wizard.vue";
import WizardTab from "@/components/Wizard/WizardTab.vue";
import "flatpickr/dist/flatpickr.css";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";
import { required } from "vee-validate/dist/rules";
import {
  Select,
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Cascader,
  DatePicker,
} from "element-ui";
import { ValidationProvider, extend } from "vee-validate";

const today = new Date();
const years = today.getFullYear();

extend("required", {
  ...required,
  message: "Este campo é obrigatório",
});
export default {
  name: "app",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Multiselect,
    Wizard,
    WizardTab,
    FileList,
    [Cascader.name]: Cascader,
    flatPicker,
    PageTitle,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [DatePicker.name]: DatePicker,
  },

  data() {
    return {
      backspacePressedPhone: false,
      active: true,
      filtered: false,
      paginated_data: {
        current: 1,
        count: 1,
        per_page: 1,
      },
      searchClient: "",
      errorToUpdate: false,
      filter: {
        anosafra: '',
        status: { label: "Atualizado", value: "updated" },
        clientChoosed: '',
        juridical: {
          seller_opinions_attributes: [{}],
          real_estate_companies_attributes: [{}],
          authorized_people_legals_attributes: [{}],
          main_customers_attributes: [{}],
          commercial_bankings_attributes: [{}],
          corporate_structures_attributes: [{}],
          desks_attributes: [{}],
          affiliated_societies_attributes: [{}],
          manager_id:'',
          consultant_id: ''
        },
      },
      juridical_statuses: [
        { label: "Atualizado", value: "updated" },
        { label: "Desatualizado", value: "outdated" },
      ],
      isLoadingJuridicals: false,
      modals: {
        header: false,
        juridicalForm: false,
      },
      safra: [],
      safras: [],
      clients: [],
      users: [],
      documentations: [],
      user: {},
      selectSafra: null,
      managers: [],
      manager: "",
      juridicals: [],
      look_like_salesman: "",
      consultant: "",
      region_id: "",
      item: "",
      config: {
        altInput: false,
        allowInput: true,
        dateFormat: "d/m/Y",
        locale: Portuguese,
      },
      isSaving: false,
      picked: "",
      fileTypes: [
        ["Ficha Cadastral", "ficha cadastral"],
        ["Estatuto Social", "estatuto social"],
        [
          "Ata da última assembléia ou Contrato Social",
          "ata da última assembléia ou contrato Social",
        ],
        [
          "Alterações Contratuais",
          "alterações contratuais",
        ],
        ["cópia Imposto de Renda dos Fiadores", "cópia Imposto de Renda dos Fiadores"],
        ["Cópia do RG / CPF dos Diretores", "cópia do RG / CPF dos Diretores"],
        ["Copia do cartão CNPJ", "copia do cartão CNPJ"],
        ["Três últimos balanços patrimoniais", "três últimos balanços patrimoniais"],
        ["Carta de Fiança.", "carta de fiança."],
      ],
      // client cri type and size
      client_types: [],
      client_sizes: [],
      cri_client: {
        client_type: {},
        client_size: {},
      }
    };
  },
  mounted() {
    this.openModalWithJuridical()
    this.getJuridicalsWithDocumentation()
    this.loadSafra();
    this.setClients();

    // get client type and size to cri-api
    this.getClientTypes()
    this.getClientSizes()

    if (this.$can("index", "user")) {
      this.getSalesmens();
    }

    if (this.currentUser.is_admin) {
      this.loadManagers();
    } else if (
      this.currentUser.is_manager ||
      this.currentUser.has_coordinateds
    ) {
      this.managers = [this.currentUser];
      this.salesmans = this.currentUser.salesmans;
      this.manager = this.currentUser;
    } else if (this.currentUser.is_salesman) {
      this.managers = [this.currentUser.manager];
      this.salesmans = [this.currentUser];
      this.manager = this.currentUser.manager;
      this.consultant = this.currentUser;
    }
  },

  methods: {
    onPhoneKeydown(e) {
      if (e.keyCode === 8) {
        return this.backspacePressedPhone = true;
      }
    },
    handleOnKeyUp(e) {
      if (e.keyCode != 8) this.backspacePressedPhone = false;
    },
    setError(error, text) {
      this.error =
        (error.response && error.response.data && error.response.data.error) ||
        text;
    },
    save() {
      if (this.filter.juridical.id) {
        this.updateClient();
        this.updateClientCri()
      } else {
        this.createClient();
      }
    },
    update() {
      if (this.filter.juridical.id)
        this.updateAdd();
    },
    async createClient() {
      this.isSaving = true;
      console.log(this.formData)
      try {
        await this.$http.secured.post(`/api/v1/clients`, this.formData);
        this.getJuridical();
        this.limpCampos();
        this.modals.juridicalForm = false;
      } catch (error) {
        if(error.response.data && error.response.data.errors && error.response.data.errors[0]){
          this.$toasted.global.defaultError({ msg: error.response.data.errors[0] });
        }
        this.$toasted.global.defaultError({msg: 'Não foi possivel cadastrar a ficha !'});
        this.setError(error, "Something went wrong");
      }

      this.isSaving = false;
    },
    limpCampos() {
      this.filter.juridical = {
        main_customers: [{}],
        corporate_structures: [{}],
        addAffiliated_societies: [{}],
        desks: [{}],
        real_estate_companies: [{}],
        authorized_people_legals: [{}],
        commercial: [{}],
        livestock_attributes: {},
        seller_opinion: [{}],
        regions: [{}],
        files: [],
        consultant_id: '',
        manager_id: ''
      };
      this.consultant = ''
      this.manager = ''
    },
    newJuridical() {
      this.limpCampos();
      this.modals.header = true;
    },
    renameFile(originalFile, newName) {
      return new File([originalFile], newName, {
        type: originalFile.type,
        lastModified: originalFile.lastModified,
      });
    },
    addFile(files, fileType) {
      const renamedFiles = [];
      for (const file of files) {
        renamedFiles.push(this.renameFile(file, `${fileType} - ${file.name}`));
      }
      console.log("renamedFiles", renamedFiles);
      this.filter.juridical = Object.assign({}, this.filter.juridical, {
        files: [...this.filter.juridical.files, ...[...renamedFiles]],
      });
    },
    translateFileType(fileType) {
      const type = this.fileTypes.find((t) => t[1] == fileType);
      return (type && type[0]) || "Outros";
    },
    edit(juridical) {
      this.getClientCri(client.code)
      this.filter.juridical = juridical;

      // Initializing form data
      this.filter.juridical = Object.assign({}, this.filter.juridical, {
        seller_opinions_attributes: this.filter.juridical.seller_opinions || [{}],
        real_estate_companies_attributes: this.filter.juridical
          .real_estate_companies || [{}],
        commercial_bankings_attributes: this.filter.juridical.commercial_bankings || [
          {},
        ],
        authorized_people_legals_attributes: this.filter.juridical
          .authorized_people_legals || [{}],
        main_customers_attributes: this.filter.juridical.main_customers || [{}],
        corporate_structures_attributes: this.filter.juridical
          .corporate_structures || [{}],
        desks_attributes: this.filter.juridical.desks || [{}],
        affiliated_societies_attributes: this.filter.juridical
          .affiliated_societies || [{}],
      });
      // this.consultant = this.filter.juridical.consultant
      // this.manager    = this.filter.juridical.manager
      this.modals.juridicalForm = true;
      // this.modals.header = true;
    },
    updateSellerOpinion() {
      console.log(this.$route.params.region)
      if (this.$route.params.region && this.$route.params.region.id && this.filter.juridical.seller_opinions_attributes) { // pego da rota de carteira de juridicales
        this.filter.juridical.seller_opinions_attributes[0].region_id = this.$route.params.region.id
        this.consultant_id = this.$route.params.region.id
      }

      else if (this.consultant && this.consultant.region && this.filter.juridical.seller_opinions_attributes) { // esse aqui da modal pegando o vendedor
        this.filter.juridical.seller_opinions_attributes[0].region_id = this.consultant.region.id
      }

      else if(this.$currentUser().region && this.$currentUser().region.id && this.filter.juridical.seller_opinions_attributes)
        this.filter.juridical.seller_opinions_attributes[0].region_id = this.$currentUser().region.id

      else {
        this.errorToUpdate = true
        this.$toasted.global.defaultError({ msg: " Para criação de parecer ou atualização, é preciso utilizar um usuário que possui região. " });
      }
    },
    async updateClient() {
      this.filter.juridical.documentation = true
      this.updateSellerOpinion()

      if (!this.errorToUpdate) {
          this.isSaving = true;
          try {
            await this.$http.secured.put(
              `/api/v1/clients/${this.filter.juridical.id}`,
              this.formData
            );
            this.getJuridicalsWithDocumentation();
            this.limpCampos();
            this.modals.juridicalForm = false;
          } catch (error) {
            this.setError(error, "Cannot delete client");
          }
          this.isSaving = false;
      }
    },
    updateClientCri () {
      const data = {
        client_size_id: this.cri_client.client_size.id,
        code: this.filter.client.code,
        client_type_id: this.cri_client.client_type.id,
        id: this.cri_client.id
      }

      this.$http.secured.put('/api/v1/credit_analysis/update_clients', data )
        .then(() => {
          console.log('Cliente CRI editado com sucesso!')
        })
        .catch((error) => (console.log(error, "Something went wrong")));
    },
    async updateAdd() {
      this.filter.juridical.documentation = true // digo que é ficha cadastral
      this.updateSellerOpinion()

      this.isSaving = true;

      if (!this.errorToUpdate) {
        try {
          await this.$http.secured.put(
            `/api/v1/clients/${this.filter.juridical.id}`,
            this.formData
          );
          this.getClientsWithDocumentation();
        } catch (error) {
          this.setError(error, "Cannot delete juridical");
        }
        this.isSaving = false;
      }
    },
    formatDate(dateString) {
      let dateParts = dateString.split(" / ");
      return finalString;
    },
    async getJuridical(q = "") {
      const data = {
        page: this.paginated_data.current,
        q: { cnpj: 15 },
      };

      if (this.filter.name) data.q.name = this.filter.name;
      if (this.filter.year) data.q.year = this.filter.year;
      if (this.filter.status) data.q.status = this.filter.status.value;

      const response = await this.$http.secured.get("/api/v1/clients", {
        params: data,
      });
      console.log(response)
      this.paginated_data = response.data;
      this.juridicals = response.data.clients;
    },
    changePage(page) {
      let filterInput = null;

      if (this.filtered) filterInput = this.filter;
      // Se algo foi pesquisado passa o parametro de filtro
      // Se não é passado parâmetro nulo
      this.setData(filterInput, page);
    },
    search() {
      this.filtered = !this.emptyFilter;
      this.setData(this.normalizedFilter);
    },

    setData(q, page) {
      //  Adicionando valores default a query e ao número da página se não definidos
      if (typeof page === "undefined") page = null;
      if (typeof q === "undefined" || this.emptyFilter) q = null;
      this.$http.secured
        .get(`/api/v1/clients`, {
          params: {
            clients_id: this.$route.params.clients_id,
            page: page,
            q: {
              ...q,
            },
          },
        })
        .then((response) => {
          // setando dados de paginação e a collection produtos
          this.paginated_data = response.data;
          this.juridicals = this.paginated_data["clients"];
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    addOpinion() {
      if (!this.filter.juridical.seller_opinions_attributes) {
        this.filter.juridical = Object.assign({}, this.filter.juridical, {
          seller_opinions_attributes: [],
        });
      }
      this.filter.juridical.seller_opinions_attributes.push({
        looks_like_salesman: "",
        customer_since: "",
        last_purchase_date: "",
        biggest_purchase_date: "",
        form_payment: "",
        credit_limit: "",
        average_delay: "",
        concept: "",
        company: "",
        informant: "",
        comments: "",
        _destroy: "",
      });
    },
    openModalWithJuridical() {
      if (this.$route.params.client) {
        this.modals.clientForm = true;
        this.filter.clientChoosed = this.$route.params.client
        this.modalValidation()
      }
    },
    async getJuridicalsWithDocumentation(q = "") {
      const data = {
        per_page: 10,
        page: this.paginated_data.current,
        q: { cnpj: 15, documentation: true },
      };

      // filter.anosafra

      if (!this.$currentUser().is_admin) {
        data.q.user_ids = this.$currentUser().id
      }

      if (this.nomeClient)    data.q.name = this.nomeClient;
      if (this.filter.year)   data.q.year = this.filter.year;
      if (this.filter.status) data.q.status = this.filter.status.value
      if (this.filter.anosafra && this.filter.anosafra.id) data.q.anosafra_ids = this.filter.anosafra.id;

      const response = await this.$http.secured.get("/api/v1/clients", {
        params: data,
      });
      this.paginated_data = response.data;
      this.documentations = response.data.clients
    },
    setClients(q = "") {
      const data = {
        per_page: 10,
        page: 1,
        grouped_by_region: true,
        q: { razao_social: q, cnpj: 15 },
      };
      if (!this.$currentUser().is_admin && this.$currentUser().is_salesman) {
        data.q.manager_ids = this.$currentUser().manager.id;
        data.q.user_ids = this.$currentUser().id;
      }
      if (this.$currentUser().is_manager)
        data.q.manager_id = this.$currentUser().id;
      if (this.safra && this.safra.id) data.q.anosafra_ids = this.safra.id;

      this.$http.secured
      .get("/api/v1/clients", { params: data })
      .then(response => {
        this.clients = response.data["clients"][0].clients;
      })
      .catch(error => this.setError(error, "failed to fetch clients"));
    },
    removeOpinion(opinion) {
      this.filter.juridical.seller_opinions_attributes = this.filter.juridical.seller_opinions_attributes.filter(
        (op) => op != opinion)
        if(opinion.id != null){
          this.filter.juridical.seller_opinions_attributes.push({
            id: opinion.id,
            _destroy: '1',
          })
        }
    },
    addCommercial() {
      if (!this.filter.juridical.commercial_bankings_attributes) {
        this.filter.juridical = Object.assign({}, this.filter.juridical, {
          commercial_bankings_attributes: [],
        });
      }
      this.filter.juridical.commercial_bankings_attributes.push({
        company: "",
        telephone: "",
        contact: "",
        name: "",
        agency: "",
        _destroy: "",
      });
    },
    removeCommercial(commercial) {
      this.filter.juridical.commercial_bankings_attributes = this.filter.juridical.commercial_bankings_attributes.filter(
        (c) => c != commercial)
        if(commercial.id != null){
          this.filter.juridical.commercial_bankings_attributes.push({
            id: commercial.id,
            _destroy: '1',
          })
        }
    },
    addAuthorized_people() {
      if (!this.filter.juridical.authorized_people_legals_attributes) {
        this.filter.juridical = Object.assign({}, this.filter.juridical, {
          authorized_people_legals_attributes: [],
        });
      }
      this.filter.juridical.authorized_people_legals_attributes.push({
        name: "",
        rg: "",
        _destroy: "",
      });
    },
    removeAuthorized(people) {
      this.filter.juridical.authorized_people_legals_attributes = this.filter.juridical.authorized_people_legals_attributes.filter(
        (p) => p != people)
        if(people.id != null){
          this.filter.juridical.authorized_people_legals_attributes.push({
            id: people.id,
            _destroy: '1',
          })
        }
    },
    addAffiliated_societies() {
      if (!this.filter.juridical.affiliated_societies_attributes) {
        this.filter.juridical = Object.assign({}, this.filter.juridical, {
          affiliated_societies_attributes: [],
        });
      }
      this.filter.juridical.affiliated_societies_attributes.push({
        address: "",
        town: "",
        state: "",
        cnpj: "",
        _destroy: "",
      });
    },
    removeAffiliated_societies(affiliated_societies) {
      this.filter.juridical.affiliated_societies_attributes = this.filter.juridical.affiliated_societies_attributes.filter(
        (b) => b != affiliated_societies)
        if(affiliated_societies != null){
          this.filter.juridical.affiliated_societies_attributes.push({
            id: affiliated_societies.id,
            _destroy: '1',
          })
        }
    },
    addReal_estate_companies() {
      if (!this.filter.juridical.real_estate_companies_attributes) {
        this.filter.juridical = Object.assign({}, this.filter.juridical, {
          real_estate_companies_attributes: [],
        });
      }
      this.filter.juridical.real_estate_companies_attributes.push({
        description: "",
        location: "",
        current_value: "",
        liens_mortgage: "",
        _destroy: "",
      });
    },
    removeReal_estate(propertie) {
      this.filter.juridical.real_estate_companies_attributes = this.filter.juridical.real_estate_companies_attributes.filter(
        (p) => p != propertie)
        if(propertie != null){
          this.filter.juridical.real_estate_companies_attributes.push({
            id: propertie.id,
            _destroy: '1',
          })
        }
    },
    addDesks() {
      if (!this.filter.juridical.desks_attributes) {
        this.filter.juridical = Object.assign({}, this.filter.juridical, {
          desks_attributes: [],
        });
      }
      this.filter.juridical.desks_attributes.push({
        company_name: "",
        cnpj: "",
        share_capital: "",
        participation: "",
        _destroy: "",
      });
    },
    removeParticipation(participation) {
      this.filter.juridical.desks_attributes = this.filter.juridical.desks_attributes.filter(
        (p) => p != participation)
        if(participation.id != null){
          this.filter.juridical.desks_attributes.push({
            id: participation.id,
            _destroy: '1',
          })
        }
    },
    addMain_customers() {
      if (!this.filter.juridical.main_customers_attributes) {
        this.filter.juridical = Object.assign({}, this.filter.juridical, {
          main_customers_attributes: [],
        });
      }
      this.filter.juridical.main_customers_attributes.push({
        name: "",
        cpf_cnpj: "",
        average_sales: "",
        participation: "",
        _destroy: "",
      });
    },
    removeMain_customers(main_customers) {
      this.filter.juridical.main_customers_attributes = this.filter.juridical.main_customers_attributes.filter(
        (m) => m != main_customers)
        if(main_customers.id != null){
          this.filter.juridical.main_customers_attributes.push({
            id: main_customers.id,
            _destroy: '1',
          })
        }
    },
    addCorporate_structures() {
      if (!this.filter.juridical.corporate_structures_attributes) {
        this.filter.juridical = Object.assign({}, this.filter.juridical, {
          corporate_structures_attributes: [],
        });
      }
      this.filter.juridical.corporate_structures_attributes.push({
        partner_directors_shareholders: "",
        cpf: "",
        office: "",
        participation: "",
        _destroy: "",
      });
    },
    removeCorporate_structures(corporate_structures) {
      this.filter.juridical.corporate_structures_attributes = this.filter.juridical.corporate_structures_attributes.filter(
        (c) => c != corporate_structures)
        if(corporate_structures.id != null){
          this.filter.juridical.corporate_structures_attributes.push({
            id: corporate_structures.id,
            _destroy: '1',
          })
        }
    },
    modalValidation() {
      this.filter.juridical = this.filter.clientChoosed
      this.modals.header = false;

      this.filter.juridical = Object.assign({}, this.filter.clientChoosed, {
        seller_opinions_attributes: this.filter.clientChoosed.seller_opinions || [{}],
        real_estate_companies_attributes: this.filter.clientChoosed
          .real_estate_companies || [{}],
        commercial_bankings_attributes: this.filter.clientChoosed.commercial_bankings || [
          {},
        ],
        authorized_people_legals_attributes: this.filter.clientChoosed
          .authorized_people_legals || [{}],
        main_customers_attributes: this.filter.clientChoosed.main_customers || [{}],
        corporate_structures_attributes: this.filter.clientChoosed
          .corporate_structures || [{}],
        desks_attributes: this.filter.clientChoosed.desks || [{}],
        affiliated_societies_attributes: this.filter.clientChoosed
          .affiliated_societies || [{}],
        files: []
      });
      // this.consultant = this.filter.juridical.consultant
      // this.manager    = this.filter.juridical.manager

      this.modals.juridicalForm = true;
    },
    loadSafra() {
      this.$http.secured
        .get("/api/v1/anosafras", { params: { unpaged: true } })
        .then((response) => {
          this.safras = response.data;
          this.safra = this.$store.state.currentAnosafra;

          if (
            !(this.safra && Object.keys(this.safra).length)
          ) {
            this.safra = this.safras[0];
          }
        });
    },
    // addBank() {
    //   if (!this.filter.client.banking_references_attributes) {
    //     this.filter.client = Object.assign({}, this.filter.client, {
    //       banking_references_attributes: [],
    //     });
    //   }
    //   this.filter.client.banking_references_attributes.push({
    //     town: "",
    //     bank_name: "",
    //     phone: "",
    //     name: "",
    //     agency: null,
    //   });
    // },
    loadManagers() {
      var data = {
        per_page: 10,
        q: {
          is_manager: true,
          anosafra_id: this.safra.id,
          status: this.active
        },
      };
      this.$http.secured
        .get("/api/v1/users", { params: data })
        .then((response) => {
          this.managers = response.data.users || [];
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    getSalesmens() {
      var data = {
        q: {
          is_salesman: true,
          manager_id: this.manager.id,
          anosafra_id: this.safra.id,
          status: this.active
        },
      };
      this.$http.secured
        .get("/api/v1/users", { params: data })
        .then((response) => {
          this.users = response.data.users || [];
        });
    },
    getCoordinator() {
      var data = {
        q: { is_coordinator: true, status: this.active },
      };
      this.$http.secured
        .get("/api/v1/users", { params: data })
        .then((response) => {
          this.users = response.data.users;
        });
    },
    getClientSizes () {
      this.$http.secured.get("/api/v1/credit_analysis/get_client_sizes")
        .then((response) => {
          this.client_sizes = response.data
        })
        .catch((error) => (console.log(error, "Something went wrong")));
    },
    getClientTypes () {
      this.$http.secured.get("/api/v1/credit_analysis/get_client_types")
        .then((response) => {
          this.client_types = response.data
        })
        .catch((error) => (console.log(error, "Something went wrong")));
    },
    getClientCri (code) {
      if(code == null) return

      this.$http.secured.get("/api/v1/credit_analysis/get_clients", { params: {code: code}})
        .then((response) => {
          this.cri_client = response.data[0]
          this.cri_client = Object.assign({}, this.cri_client)

          if (this.cri_client.size_object) {
            this.cri_client.client_size = this.cri_client.size_object
          }

          if (this.cri_client.type_object) {
            this.cri_client.client_type = this.cri_client.type_object
          }
        })
        .catch((error) => (console.log(error, "Something went wrong")));
    },
  },
  computed: {
    isEditing() {
      return this.filter.juridical ? true : false;
    },
    formData() {
      return this.$buildFormData(this.filter.juridical, "cliente");
    },
    /** Groups files by filetype */
    groupedFiles() {
      console.log("groupedFiles")
      console.log(this.filter.juridical.files)
      if (!(this.filter.juridical && this.filter.juridical.files)) return {};
      const response = {};

      this.fileTypes.forEach((type) => {
        console.log(type)
        response[type[1]] = this.filter.juridical.files.filter((f) =>
          f.name.match(`${type[1]} - `)
        );
      });
      response.outros = this.filter.juridical.files.filter(
        (f) => !Object.values(response).flat().includes(f)
      );
      console.log(response)
      return response;
    },
    reqParams: function () {
      if (this.juridicals.hasOwnProperty("id")) {
        return {
          url: `/api/v1/clients/${this.juridicals.id}`,
          method: "patch",
          data: {
            ...this.juridicals,
          },
        };
      }
      return {
        url: "/api/v1/clients",
        method: "post",
        data: {
          ...this.juridicals,
        },
      };
    },
    emptyFilter: function () {
      for (var key in this.filter) {
        if (
          this.filter.hasOwnProperty(key) &&
          this.filter[key] != "" &&
          typeof this.filter[key] != "undefined"
        ) {
          return false;
        }
      }
      return true;
    },
    normalizedFilter: function () {
      let filter = this.filter;
      for (let key in filter) {
        // replacing objects by ids
        if (filter.hasOwnProperty(key) && typeof filter[key] == "object") {
          if (filter[key].hasOwnProperty("id")) {
            filter[key + "_id"] = filter[key].id;
            delete filter[key];
          } else {
            filter[key] = filter[key].value;
          }
        }
        // removing empty fields
        if (filter[key] == "") {
          delete filter[key];
        }
      }

      return filter;
    },
  },
  watch: {
    "juridical.name": function (val) {
      this.filter.juridical.razao_social = val;
    },
    consultant(val) {
      this.filter.juridical.consultant_id = val.id;
      this.setClients();
    },
    manager(val) {
      this.filter.juridical.manager_id = val.id;
      this.getSalesmens()
    },
    safra() {
      if (this.currentUser.is_admin) this.loadManagers();
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>
<style scoped>
.cascader {
  width: 360px;
}
.space {
  padding: 10px;
}

.metade {
  width: 60px;
  height: 100%;
  background-color: green;
}

.farmInput {
  width: 100%;
}

.button-culture {
  position: relative;
  left: 350px;
  top: -20px;
}

.button-person {
  position: relative;
  left: 350px;
  top: -20px;
}
.checkboxtext {
  padding-top: 61px;
}
.labelCheck {
  margin-right: 13px;
}
.divContent {
  overflow: auto;
}
</style>
